import { TaskStatus } from '../../../models';

export const taskStatusTypeMapper = (status: TaskStatus, isLate?: boolean) => {
  if (isLate) {
    return 'Late';
  }

  switch (status) {
    case TaskStatus.InProgress:
      return 'In progress';
    case TaskStatus.Cancelled:
      return 'Cancelled';
    case TaskStatus.Completed:
      return 'Completed';
    case TaskStatus.Late:
      return 'Late';
  }
};
